import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';

@Component({
    selector: 'key-log-filter',
    templateUrl: './key-log-filter.component.html',
    styleUrls: ['./key-log-filter.component.scss']
})
export class KeyLogFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('availableCheckbox') available: ElementRef;
    @ViewChild('unavailableCheckbox') unavailable: ElementRef;
    @ViewChild('signedOutCheckbox') signedOut: ElementRef;

    constructor(
        private urlService: UrlService
    ) {}

    ngOnInit() {
        const status = this.urlService.queryParams['status'];

        this.urlService.onUrlChange.subscribe(_ => {
            if (!_.status) {
                this.available.nativeElement.checked = false;
                this.signedOut.nativeElement.checked = false;
            }
        });
        if (status) {
            this.available.nativeElement.checked = status.indexOf('availableCheckbox') !== -1;
            this.signedOut.nativeElement.checked = status.indexOf('signedOutCheckbox') !== -1;
        }
    }

    changeFilter() {
        const availableValue = this.available.nativeElement.checked;
        const signedOutValue = this.signedOut.nativeElement.checked;

        if (!availableValue && !signedOutValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (availableValue) status += 'available,';
            if (signedOutValue) status += 'signet_out,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('key-log-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/key-log-filter/key-log-filter.component.ts